(function () {
  if (window.c_cartReady) return;
  window.c_cartReady = true;

  var c_root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var c_stateKey = 'grf_ship_state';

  function c_isCartPage() {
    return !!document.querySelector('[data-cart-page]');
  }

  function c_bundledSections() {
    var c_sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: c_sections } }));
    return c_sections;
  }

  function c_post(path, body) {
    return fetch(c_root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function c_busy(element, on) {
    var c_scope = element && (element.closest('[data-cart-line]') || element.closest('[data-cart-card]') || element);
    if (!c_scope) return;
    if (on) c_scope.setAttribute('data-cart-busy', '');
    else c_scope.removeAttribute('data-cart-busy');
  }

  function c_say(element, kind) {
    var c_live = document.querySelector('[data-cart-live]');
    var c_item = element && element.closest('[data-title]');
    if (!c_live || !c_item) return;
    var c_text = (c_live.getAttribute(kind === 'add' ? 'data-added' : 'data-removed') || '').replace('[title]', c_item.getAttribute('data-title'));
    c_live.textContent = '';
    setTimeout(function () { c_live.textContent = c_text; }, 100);
  }

  function c_announce(cart, baseEvent) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: baseEvent, cart: cart } }));
  }

  function c_showError(element, error) {
    var c_line = element.closest('[data-cart-line]') || element.closest('[data-cart-card]');
    if (!c_line) return;
    var c_message = c_line.querySelector('[data-cart-error]');
    if (!c_message) return;
    c_message.textContent = (error && (error.description || error.message)) || '';
    c_message.hidden = false;
  }

  function c_change(element, key, quantity, properties) {
    c_busy(element, true);
    var c_sections = c_isCartPage() ? [] : c_bundledSections();
    var c_body = { id: key, quantity: quantity, sections: c_sections.join(',') };
    if (properties) c_body.properties = properties;
    c_post('cart/change.js', c_body)
      .then(function (cart) {
        if (c_isCartPage()) return window.location.reload();
        if (quantity === 0) c_say(element, 'remove');
        c_announce(cart, 'line-item:change');
      })
      .catch(function (error) {
        c_busy(element, false);
        c_showError(element, error);
      });
  }

  function c_add(element, variantId) {
    c_busy(element, true);
    var c_sections = c_isCartPage() ? [] : c_bundledSections();
    c_post('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }], sections: c_sections.join(',') })
      .then(function (added) {
        if (c_isCartPage()) return window.location.reload();
        return fetch(c_root + 'cart.js').then(function (response) { return response.json(); }).then(function (cart) {
          cart.sections = added.sections;
          c_say(element, 'add');
          c_announce(cart, 'variant:add');
        });
      })
      .catch(function (error) {
        c_busy(element, false);
        c_showError(element, error);
      });
  }

  function c_updateCart(body) {
    return c_post('cart/update.js', body);
  }

  function c_readState() {
    try { return window.localStorage.getItem(c_stateKey) || ''; } catch (e) { return ''; }
  }

  function c_writeState(state) {
    try { window.localStorage.setItem(c_stateKey, state); } catch (e) {}
  }

  function c_applyState() {
    var c_state = c_readState();
    var c_data = document.querySelector('[data-ship-windows]');
    if (!c_state || !c_data) return;
    var c_windows = {};
    try { c_windows = JSON.parse(c_data.textContent); } catch (e) { return; }
    var c_month = c_windows[c_state];
    document.querySelectorAll('[data-ship-line]').forEach(function (line) {
      var c_template = c_month ? line.getAttribute('data-ship-known') : line.getAttribute('data-ship-unknown');
      if (!c_template) return;
      line.textContent = c_template.replace('[state]', c_state).replace('[month]', c_month || '');
    });
    document.querySelectorAll('[data-ship-select]').forEach(function (select) {
      select.value = c_state;
    });
  }

  var c_noteTimer;
  var c_drawerTab = 'basket';
  var c_drawerChip = '';
  var c_addFromDrawer = false;
  var c_addedIds = [];

  function c_selectChip(tabs, name) {
    var c_found = false;
    tabs.querySelectorAll('[data-cart-tab]').forEach(function (tab) {
      if (tab.getAttribute('data-cart-tab') === name) c_found = true;
    });
    if (!c_found) return false;
    tabs.querySelectorAll('[data-cart-tab]').forEach(function (tab) {
      var c_active = tab.getAttribute('data-cart-tab') === name;
      tab.classList.toggle('is-active', c_active);
      tab.setAttribute('aria-selected', c_active ? 'true' : 'false');
      tab.tabIndex = c_active ? 0 : -1;
    });
    tabs.querySelectorAll('[data-cart-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-cart-panel') !== name;
    });
    return true;
  }

  function c_showDrawerTab(name, focus) {
    var c_drawer = document.getElementById('cart-drawer');
    if (!c_drawer) return;
    c_drawerTab = name;
    c_drawer.querySelectorAll('[data-cdr-tab]').forEach(function (tab) {
      var c_active = tab.getAttribute('data-cdr-tab') === name;
      tab.setAttribute('aria-selected', c_active ? 'true' : 'false');
      tab.tabIndex = c_active ? 0 : -1;
      if (c_active && focus) tab.focus();
    });
    c_drawer.querySelectorAll('[data-cdr-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-cdr-panel') !== name;
    });
  }

  document.addEventListener('click', function (event) {
    var c_target = event.target.closest('[data-cart-qty], [data-cart-remove], [data-cart-add], [data-cart-tab], [data-cdr-tab], [data-ship-toggle], [data-discount-apply], [data-discount-remove]');
    if (!c_target) return;

    if (c_target.hasAttribute('data-cdr-tab')) {
      c_showDrawerTab(c_target.getAttribute('data-cdr-tab'));
    } else if (c_target.hasAttribute('data-cart-qty')) {
      event.preventDefault();
      c_change(c_target, c_target.getAttribute('data-key'), Number(c_target.getAttribute('data-cart-qty')));
    } else if (c_target.hasAttribute('data-cart-remove')) {
      event.preventDefault();
      c_change(c_target, c_target.getAttribute('data-key'), 0);
    } else if (c_target.hasAttribute('data-cart-add')) {
      event.preventDefault();
      c_addFromDrawer = !!c_target.closest('#cart-drawer');
      var c_card = c_target.closest('[data-product-id]');
      if (c_addFromDrawer && c_card) c_addedIds.push(c_card.getAttribute('data-product-id'));
      c_add(c_target, c_target.getAttribute('data-cart-add'));
    } else if (c_target.hasAttribute('data-cart-tab')) {
      var c_name = c_target.getAttribute('data-cart-tab');
      c_selectChip(c_target.closest('[data-cart-tabs]'), c_name);
      if (c_target.closest('#cart-drawer')) c_drawerChip = c_name;
    } else if (c_target.hasAttribute('data-ship-toggle')) {
      var c_picker = c_target.closest('[data-cart-line]').querySelector('[data-ship-picker]');
      if (!c_picker) return;
      c_picker.hidden = !c_picker.hidden;
      var c_date = c_picker.querySelector('[data-ship-date]');
      if (c_date && !c_picker.hidden) {
        c_date.focus();
        try { c_date.showPicker(); } catch (e) {}
      }
    } else if (c_target.hasAttribute('data-discount-apply')) {
      var c_form = c_target.closest('[data-discount]');
      var c_input = c_form.querySelector('input');
      var c_code = c_input.value.trim();
      if (!c_code) return;
      var c_codes = (c_form.getAttribute('data-codes') || '').split(',').filter(Boolean);
      c_codes.push(c_code);
      c_busy(c_target, true);
      c_updateCart({ discount: c_codes.join(',') }).then(function () { window.location.reload(); }).catch(function () { c_busy(c_target, false); });
    } else if (c_target.hasAttribute('data-discount-remove')) {
      var c_wrap = c_target.closest('[data-discount]');
      var c_remove = c_target.getAttribute('data-discount-remove');
      var c_left = (c_wrap.getAttribute('data-codes') || '').split(',').filter(function (code) { return code && code !== c_remove; });
      c_updateCart({ discount: c_left.join(',') }).then(function () { window.location.reload(); });
    }
  });

  document.addEventListener('change', function (event) {
    var c_target = event.target;
    if (c_target.matches('[data-ship-select]')) {
      c_writeState(c_target.value);
      c_applyState();
      var c_picker = c_target.closest('[data-ship-picker]');
      if (c_picker) c_picker.hidden = true;
    } else if (c_target.matches('[data-ship-date]')) {
      if (!c_target.value) return;
      var c_props = {};
      try { c_props = JSON.parse(c_target.getAttribute('data-properties')) || {}; } catch (e) {}
      if (Array.isArray(c_props)) c_props = {};
      c_props[c_target.getAttribute('data-property')] = c_target.value;
      c_change(c_target, c_target.getAttribute('data-key'), Number(c_target.getAttribute('data-quantity')), c_props);
    } else if (c_target.matches('[data-gift-toggle]')) {
      var c_note = document.querySelector('[data-gift-note]');
      if (c_note) c_note.hidden = !c_target.checked;
      if (!c_target.checked) c_updateCart({ note: '' });
    }
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-gift-note] textarea')) return;
    var c_value = event.target.value;
    clearTimeout(c_noteTimer);
    c_noteTimer = setTimeout(function () { c_updateCart({ note: c_value }); }, 500);
  });

  document.addEventListener('keydown', function (event) {
    var c_tab = event.target.closest && event.target.closest('[data-cdr-tab], [data-cart-tab]');
    if (!c_tab) return;
    var c_attr = c_tab.hasAttribute('data-cdr-tab') ? 'data-cdr-tab' : 'data-cart-tab';
    var c_group = c_tab.closest(c_attr === 'data-cdr-tab' ? '[data-cdr-tabs]' : '[data-cart-tabs]');
    var c_tabs = Array.prototype.slice.call(c_group.querySelectorAll('[' + c_attr + ']'));
    var c_index = c_tabs.indexOf(c_tab);
    if (event.key === 'ArrowRight') c_index = (c_index + 1) % c_tabs.length;
    else if (event.key === 'ArrowLeft') c_index = (c_index - 1 + c_tabs.length) % c_tabs.length;
    else if (event.key === 'Home') c_index = 0;
    else if (event.key === 'End') c_index = c_tabs.length - 1;
    else return;
    event.preventDefault();
    var c_name = c_tabs[c_index].getAttribute(c_attr);
    if (c_attr === 'data-cdr-tab') {
      c_showDrawerTab(c_name, true);
    } else {
      c_selectChip(c_group, c_name);
      if (c_group.closest('#cart-drawer')) c_drawerChip = c_name;
      c_tabs[c_index].focus();
    }
  });

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.baseEvent === 'variant:add' && !c_addFromDrawer) c_drawerTab = 'basket';
    c_addFromDrawer = false;
  });

  document.addEventListener('dialog:before-show', function (event) {
    if (event.target.id !== 'cart-drawer') return;
    c_addedIds = [];
    c_drawerChip = '';
    c_showDrawerTab('basket');
  }, true);

  document.addEventListener('cart-drawer:refreshed', function () {
    var c_drawer = document.getElementById('cart-drawer');
    c_showDrawerTab(c_drawerTab);
    var c_chips = c_drawer && c_drawer.querySelector('[data-cart-tabs]');
    if (c_chips && c_drawerChip) c_selectChip(c_chips, c_drawerChip);
    c_addedIds.forEach(function (id) {
      c_drawer.querySelectorAll('[data-in-box][data-product-id="' + id + '"]').forEach(function (card) {
        card.hidden = false;
      });
    });
  });
  document.addEventListener('cart-drawer:refreshed', c_applyState);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', c_applyState);
  else c_applyState();
})();
